<div
  class="input-container"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  [attr.data-has-value]="hasValue"
>
  <label *ngIf="label" class="input-label" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="input-wrapper">
    <!-- Prefix Icon -->
    <span
      *ngIf="prefixIconName"
      class="input-icon input-icon-prefix"
      role="button"
      tabindex="0"
      (click)="onPrefixIconClick()"
      (keydown.enter)="onPrefixIconClick()"
      (keydown.space)="onPrefixIconClick()"
    >
      <umss-icon [name]="prefixIconName" [size]="iconSize"></umss-icon>
    </span>

    <!-- Prefix Text -->
    <span *ngIf="prefix && !prefixIconName" class="input-text-prefix">
      {{ prefix }}
    </span>

    <!-- Input Field -->
    <input
      class="input-field"
      [type]="inputType"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [mask]="appliedMask"
      [keepCharacterPositions]="true"
      [dropSpecialCharacters]="false"
      [formControl]="inputControl"
      [attr.name]="name"
      [attr.id]="inputId"
      [attr.autocomplete]="autocomplete"
      [attr.maxlength]="maxlength"
      [attr.minlength]="minlength"
      [attr.pattern]="pattern"
      [attr.inputmode]="appliedInputmode"
      [attr.min]="min"
      [attr.max]="max"
      [attr.step]="step"
      [attr.accept]="accept"
      [attr.multiple]="multiple"
      [attr.tabindex]="tabindex"
      [attr.aria-label]="label"
      [attr.aria-required]="required"
      [attr.aria-invalid]="error"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
    />

    <!-- Suffix Text -->
    <span
      *ngIf="suffix && !suffixIconName && type !== 'password'"
      class="input-text-suffix"
    >
      {{ suffix }}
    </span>

    <!-- Password Toggle Icon -->
    <span
      *ngIf="type === 'password'"
      class="input-icon input-icon-suffix password-toggle"
      role="button"
      tabindex="0"
      (click)="togglePasswordVisibility()"
      (keydown.enter)="togglePasswordVisibility()"
      (keydown.space)="togglePasswordVisibility()"
    >
      <umss-icon [name]="passwordToggleIcon" [size]="iconSize"></umss-icon>
    </span>

    <!-- Suffix Icon -->
    <span
      *ngIf="suffixIconName && type !== 'password'"
      class="input-icon input-icon-suffix"
      role="button"
      tabindex="0"
      (click)="onSuffixIconClick()"
      (keydown.enter)="onSuffixIconClick()"
      (keydown.space)="onSuffixIconClick()"
    >
      <umss-icon [name]="suffixIconName" [size]="iconSize"></umss-icon>
    </span>
  </div>

  <p *ngIf="helperText && !error" class="helper-text">
    {{ helperText }}
  </p>

  <p *ngIf="error && errorMessage" class="error-message">
    {{ errorMessage }}
  </p>
</div>
